import { render, staticRenderFns } from "./retpwd.vue?vue&type=template&id=95ace9e8"
import script from "./retpwd.vue?vue&type=script&lang=js"
export * from "./retpwd.vue?vue&type=script&lang=js"
import style0 from "./retpwd.vue?vue&type=style&index=0&id=95ace9e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports